import * as React from 'react';
import { SwatchProps } from './Swatch.types';
import './styles/Swatch.css';

export const Swatch = ({
    value,
    onClick,
    caption,
    selected
}: SwatchProps) => {
    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            onClick();
        }
    }
    return (
        <button
            className={`
                swatch
                ${selected ? `swatch--selected` : null}
            `}
            data-value={value}
            onClick={onClick}
            onKeyDown={handleKeyDown}
        >
            <div className="swatch__image" />
            {caption ? (
                <span className="swatch__caption">
                    {caption}
                </span>
            ) : (
                <span className="sr-only">{value}</span>
            )}
        </button>
    );
    
};